<template>
  <DxPopup @hidden="onHidden" :visible="showEpmsZ005" :show-close-button="true" :show-title="true" :title="'Files Control'" height="900" width="1280" container=".v-application">
    <DxScrollView
      width="100%"
      height="100%"
      direction="both"
    >
      <v-row no-gutters style="max-width: 1246px;">
        <v-col>
          <DxDataGrid
            :ref="epmsZ005Ref"
            :data-source="dataList" 
            :remote-operations="false" 
            :hover-state-enabled="true"
            :allow-column-resizing="true" 
            :allow-column-reordering="true"
            :row-alternation-enabled="true" 
            :show-borders="true" 
            :width="grid.width"
            :show-row-lines="true" 
            key-expr="id" 
            :focused-row-enabled="true"
            :column-hiding-enabled="false" 
            :selection="{ mode: 'none' }"
            :sorting="{ mode: 'none' }"
            @rowClick="rowClick"
          >
            <DxPaging :enabled="true" :page-size="setPageRows" />
            <DxPager :show-page-size-selector="false" />
            <DxEditing :allow-updating="true" />
            <DxColumn data-field="id" caption="No" width="10%" alignment="center" :allow-editing="false" />
            <DxColumn data-field="fileName" caption="File Name" width="20%" alignment="left" :allow-editing="false"
                                  cell-template="fileNameCellTmpl" />
            <template #fileNameCellTmpl="{ data: cellInfo }">
              <!-- <a :href="cellInfo.data.linkPath" target="_blank" style="text-decoration: none; color: #000000;" class="text-bold">
                {{ cellInfo.data.fileName }}
              </a> -->
              <a @click.stop="openWindow(cellInfo.data.linkPath)" target="_blank" style="text-decoration: none; color: #000000;" class="text-bold">
                {{ cellInfo.data.fileName }}
              </a>
            </template>
            <DxColumn data-field="fileDesc" caption="Description" width="30%" alignment="left" :allow-editing="false" />
            <DxColumn data-field="linkPath" caption="Link Path" alignment="left" :allow-editing="false" />
          </DxDataGrid>
        </v-col>
      </v-row>

      <v-row no-gutters style="max-width: 1246px;">
        <v-col>
          <i-card-top class="d-md-flex">
            <template v-slot:body>
              <v-row no-gutters class="pa-2">
                <v-col cols="4">
                  <v-file-input class="pa-0" placeholder="File input" v-model="selectedFile" />
                </v-col>

                <v-col cols="8" class="d-flex justify-end align-center">
                  <div style="width: 150px;">
                    <v-select
                      v-model="selectFileKind"
                      :items="fileKindList"
                      return-object
                      item-text="codeName"
                      item-value="code"
                      single-line
                      outlined
                      dense
                      height="32" />
                  </div>

                  <div style="width: 300px;">
                    <v-text-field
                      class="pl-2"
                      v-model="fileDesc"
                      dense 
                      outlined 
                      hide-details="auto"
                      clearable
                      height="32"
                    />
                  </div>
                  
                  <i-button :text="'Upload'" :isCustom="true" @click="btnUpload()" class="pl-2" />
                </v-col>
              </v-row>
            </template>
          </i-card-top>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col class="d-flex justify-center">
          <b>[Preview]</b>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col class="d-flex justify-center">
          <div v-html="previewString" />
        </v-col>
      </v-row>
    </DxScrollView>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import iButton from '@/components/common/iButton'
import { getCmChildCode } from '@/api/system/cmCodeManage'
import { DxScrollView } from 'devextreme-vue/scroll-view'
import { epmsZ005List, epmsZ005Save, getContents } from '@/api/view/hip/Z/epmsZ000'
import notify from 'devextreme/ui/notify'

export default {
  name: 'epmsZ005',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxPopup,
    iButton,
    DxScrollView
  },
  props: {
    showEpmsZ005: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  watch: {
    'showEpmsZ005': {
      handler(value, oldValue) {
        if(value) {
          this.init()
        } else {
          this.previewString = ''
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      userId: this.$store.state.user.userId,
      epmsZ005Ref: 'epmsZ005Ref',
      setPageRows: 15,
      dataList: [],
      selectedFile: null,
      fileDesc: '',
      selectFileKind: null,
      fileKindList: [],
      previewString: ''
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsZ005Ref)
    }
  },
  methods: {
    async init() {
      await this.getFileKinds()
      await this.getData()
    },
    async getFileKinds() {
      await getCmChildCode({
        code: '',
        codegr: '',
        prtCode: 'FILE_KIND',
        userFlag: 'Y'
      }).then(res => {
        // console.log('res', res)

        this.fileKindList = res.list
        this.selectFileKind = this.fileKindList[0]
      })
    },
    async getData() {
      this.dataList = []

      const param = {
        fileKind: this.selectFileKind.code
      }

      // console.log('getData Param', param)

      await epmsZ005List(param).then(res => {
        let data = res.list

        for(let i = 0; i < data.length; i++) {
          data[i].id = i + 1
        }

        this.dataList = data
      })
    },
    btnUpload() {
      if(!this.selectedFile) {
        this.vToastify(this.$t('Select upload file.'), 'warn')
        return
      }

      if(!this.selectFileKind || !this.selectFileKind.code) {
        this.vToastify(this.$t('Choose file kind.'), 'warn')
        return
      }

      this.vToastifyPrompt(
        this.$t('Do you want to upload file?'),
        'info',
        async current => {
          const formData = new FormData()
          formData.append('fileName', this.selectedFile)
          formData.append('fileKind', this.selectFileKind.code)
          formData.append('fileDesc', this.fileDesc)
          formData.append('userId', this.userId)

          this.openLoading()
          epmsZ005Save(formData).then(res => {
            const msg = res.body
            if(msg === 'OK') {
              notify(this.$t('Upload is completed.'), 'success', 3000)
              
              this.getData()
            } else {
              this.vToastify(this.$t('An error has occured while uploading file.'), 'warn')
            }
          }).finally(() => {
            this.endLoading()
          })
        },
        null,
        false
      )
    },
    rowClick(e) {
      // console.log('rowClick Event', e)

      if(e.rowType === 'data') {
        if(e.rowIndex >= 0) {
          const data = e.data

          if(data.fileKind === 'IMG') {
            this.openLoading()
            getContents(
              data.linkPath.replace(/http:\/\/ebiz.hvs.com.vn/g, '/tosrc')
            ).then(res => {
              this.previewString = `<img src="data:${res.headers['content-type']};base64,${res.body}">`
            }).catch(err => {
              this.vToastify(this.$t('Failed to content download'), 'warn')
            }).finally(() => {
              this.endLoading()
            })
          } else {
            this.previewString = 'Cannot preview.'
          }
        }
      }
    },
    openWindow(link) {
      // console.log('openWindow link', link)

      this.openLoading()
      getContents(
        link.replace(/http:\/\/ebiz.hvs.com.vn/g, '/tosrc')
      ).then(res => {
        let img = new Image()
        img.src = `data:${res.headers['content-type']};base64,${res.body}`
        let win = window.open('')
        win.document.write(img.outerHTML)
        win.document.body.style.background = '#0e0e0e'
      }).catch(err => {
        this.vToastify(this.$t('Failed to content download'), 'warn')
      }).finally(() => {
        this.endLoading()
      })
    },
    onHidden(e) {
      this.$emit('update:showEpmsZ005', false)
    }
  },
  mounted() {
    // console.log('this.gridInstance.option', this.gridInstance.option)
    this.gridInstance.option('defaultPaging', false)
  }
}
</script>

<style lang="scss" scoped>

</style>